<template>
  <div :class="Logincss" class="relative w-full h-screen px-4">
    <span class="-enter-x xl:hidden">
      <AppLogo :alwaysShowTitle="true" />
    </span>
    <div class="container relative h-full py-2 mx-auto sm:px-10">
      <div class="static flex justify-center h-full pt-10 xl:justify-start">
        <div class="hidden min-h-full pt-10 pl-4 mr-4 xl:flex xl:flex-col xl:w-6/12">
          <AppLogo class="mt-10 -enter-x" />
          <div class="my-auto">
            <img src="../../assets/svg/login-box-bg.svg" class="w-1/2 -mt-16 -enter-x" />
          </div>
        </div>
        <div class="flex w-full h-full py-5 xl:h-auto xl:py-0 xl:my-0 xl:w-6/12">
          <div
            :class="`${'www2'}-form`"
            class="relative w-full px-5 py-8 mx-auto my-auto rounded-md shadow-md xl:ml-16 xl:bg-transparent sm:px-8 xl:p-4 xl:shadow-none sm:w-3/4 lg:w-2/4 xl:w-auto enter-x"
          >
            <Login></Login>
          </div>
        </div>

        <div class="absolute flex bottom-20">
          <a class="text-white" href="https://beian.miit.gov.cn/" target="_blank">{{
            store.getters.getConfig.icp
          }}</a>
          <img src="../../assets/images/gongan.png" class="object-none ml-4" style="float: left" />
          <a
            target="_blank"
            class="ml-2 text-white"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33100202001322"
            >{{ store.getters.getConfig.gov_record }}</a
          >
        </div>
      </div>
    </div>
    <!-- <span>
      <AppLogo></AppLogo>
    </span> -->
  </div>
</template>
<script>
  // import { contractFxqCheck } from '@/api/contract';
  // import CheckModal from './module/checkModal.vue';
  import { mapState } from 'vuex';
  import Login from '@/layout/content/xbjjlogin/login.vue';
  import store from '@/store/index';

  import AppLogo from '@/components/Application/AppLogo.vue';
  export default {
    components: {
      AppLogo,
      Login,
    },
    data() {
      return {
        loading: false,
        store: store,
        flag: false,
        checkInfo: {},
        Logincss: 'www2-login',
      };
    },
    computed: {
      ...mapState('user', ['loginFlag', 'userInfo']),
    },
    mounted() {
   
    },
    methods: {
      async login() {
        store.commit('user/SET_LOGINFLAG', true);
      },
      cancelLogin() {
        this.$store.commit('user/SET_LOGINFLAG', false);
      },
    },
  };
</script>
<style scoped lang="less">
  @import '../../assets/less/breakpoint.less';
  @namespace: 'www2';
  @prefix-cls: ~'@{namespace}-login';
  @logo-prefix-cls: ~'@{namespace}-app-logo';
  @countdown-prefix-cls: ~'@{namespace}-countdown-input';
  @dark-bg: #293146;
  :deep(.ant-btn-primary:hover, .ant-btn-primary:focus) {
    color: #fff;
    border-color: #2a7dc9;
    background: #2a7dc9;
  }
  html[data-theme='dark'] {
    .@{prefix-cls} {
      background-color: @dark-bg;

      &::before {
        background-image: url(/@/assets/svg/login-bg-dark.svg);
      }

      .ant-input,
      .ant-input-password {
        background-color: #232a3b;
      }

      .ant-btn:not(.ant-btn-link):not(.ant-btn-primary) {
        border: 1px solid #4a5569;
      }

      &-form {
        background: transparent !important;
        background: #000;
      }

      .app-iconify {
        color: #fff;
      }
    }

    input.fix-auto-fill,
    .fix-auto-fill input {
      -webkit-text-fill-color: #c9d1d9 !important;
      box-shadow: inherit !important;
    }
  }

  .@{prefix-cls} {
    min-height: 100%;
    overflow: hidden;
    background-image: url(/@/assets/svg/login-bg.svg);

    @media (max-width: @screen-xl) {
      background-color: #293146;

      :deep(.www2-form) {
        background-color: #fff;
      }
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      margin-left: -48%;
      background-image: url(../../assets/svg/login-bg.svg);
      background-position: 100%;
      background-repeat: no-repeat;
      background-size: auto 100%;
      content: '';
      @media (max-width: @screen-xl) {
        display: none;
      }
    }

    .@{logo-prefix-cls} {
      position: absolute;
      top: 12px;
      height: 30px;

      &__title {
        font-size: 16px;
        color: #fff;
      }

      img {
        width: 32px;
      }
    }

    .container {
      .@{logo-prefix-cls} {
        display: flex;
        width: 60%;
        height: 80px;
        :deep(.www2-app-logo__title) {
          font-size: 24px !important;
          color: #fff !important;
        }

        img {
          width: 48px !important;
        }
      }
    }

    &-sign-in-way {
      .anticon {
        font-size: 22px;
        color: #888;
        cursor: pointer;

        &:hover {
          color: @primary-color;
        }
      }
    }

    :deep(input:not([type='checkbox'])) {
      min-width: 360px;

      @media (max-width: @screen-xl) {
        min-width: 320px;
      }

      @media (max-width: @screen-lg) {
        min-width: 260px;
      }

      @media (max-width: @screen-md) {
        min-width: 240px;
      }

      @media (max-width: @screen-sm) {
        min-width: 160px;
      }
    }

    .@{countdown-prefix-cls} input {
      min-width: unset;
    }

    .ant-divider-inner-text {
      font-size: 12px;
      color: @text-color-secondary;
    }
  }
</style>
